import { useEffect, useRef } from 'react';
import { useGetCurrentUserQuery } from '../features/apis/authApi';
import { useNavigate } from 'react-router-dom';
import type { User } from '../types/userTypes';

const useCurrentUser = (): User | undefined => {
  const { data, currentData, isLoading, isFetching, isError } =
    useGetCurrentUserQuery();
  const navigate = useNavigate();
  const logoutHandled = useRef(false); // ✅ prevents multiple logout

  let user: User | undefined = undefined;

  if (data && !isLoading && !isFetching) {
    user = data.User;
  }

  useEffect(() => {
    if (isError && !data && !currentData && !logoutHandled.current) {
      logoutHandled.current = true; // mark logout as handled
      console.log('Error fetching current user', isError);
      navigate('/');
    }
  }, [isError, data, currentData, navigate]);

  return user;
};

export default useCurrentUser;
